@if (!loading) {
  @if (showPaymentTypeDetailsDialog) {
    <!-- details dialog -->
    <p-dialog [header]="i18n?.i18nLng()['DETAILS']"
              [modal]="true"
              [(visible)]="showPaymentTypeDetailsDialog"
              [style]="{width: '57rem'}"
              [closable]="true"
              [resizable]="false"
              [draggable]="false"
              (visibleChange)="$event === false ? closeDetailsDialog() : null">
      <customer-payment-type-details-dialog [paymentTypeData]="selectedRowData"
                                            [tenantId]="paymentDataService.selectedOrganisationData?.displayCustomerNumber"
                                            titleColumnWidth="200px">
      </customer-payment-type-details-dialog>
      <ng-template #footer class="pt-3">
        <p-button [label]="i18n.i18nLng()['CLOSE']" (onClick)="closeDetailsDialog()"/>
      </ng-template>
    </p-dialog>
  }

  @if (showAddPaymentTypeDialog) {
    <!-- add payment type dialog -->
    <p-dialog [modal]="true"
              [focusOnShow]="false"
              [(visible)]="showAddPaymentTypeDialog"
              [style]="{width: '50rem'}"
              [closable]="false"
              [resizable]="false"
              [draggable]="false"
              styleClass="custom-header-dialog">
      <ng-template #header>
        <div>
          <span class="p-dialog-title">{{ i18n?.i18nLng()['ADDPAYMENTTYPE'] }}</span>
        </div>
        <p-button icon="pi pi-times"
                  [text]="true"
                  [rounded]="true"
                  styleClass="p-dialog-close-button"
                  severity="secondary"
                  [attr.aria-label]="i18n.i18nLng()['CLOSE']"
                  (click)="cancelAddPaymentType()"/>
      </ng-template>


      <div class="flex flex-column align-items-start gap-3 align-self-stretch pb-4">
        <fieldset class="sps-fieldset form-data-container separator">
          <div class="grid w-full">
            <div class="col-12 flex flex-column gap-2">
              <label for="pctype">{{ i18n.i18nLng()['PAYMENTMETHOD'] }}<sup class="sps-sup">*</sup></label>
              <p-select [(ngModel)]="newPaymentType.paymentMethod"
                        [autofocus]="true"
                        inputId="pctype"
                        [options]="paymentMethodList"
                        [showClear]="false"
                        [placeholder]="i18n.i18nLng()['PLACEHOLDERSELECT']"
                        optionLabel="label"
                        optionValue="value"
                        class="w-full"
                        size="large"
                        appendTo="body"
                        [attr.aria-label]="i18n.i18nLng()['PAYMENTMETHOD']"
                        [attr.aria-invalid]="paymentInvalidFlags.paymentMethod"
                        [attr.aria-describedby]="paymentInvalidFlags.paymentMethod ? 'type-invalid-help' : null"
                        [ngClass]="paymentInvalidFlags.paymentMethod ? 'ng-invalid ng-dirty' : null"/>
              @if (paymentInvalidFlags.paymentMethod) {
                <small style="line-height: 1.5rem" class="text-error" role="alert" id="type-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
              }
            </div>
            <div class="col-12 flex flex-column gap-2">
              <label for="account-name">{{ i18n.i18nLng()['PAYMENTMETHODDESC'] }}<sup class="sps-sup">*</sup></label>
              <input pInputText
                     id="account-name"
                     maxlength="80"
                     [(ngModel)]="newPaymentType.title"
                     [required]="true"
                     [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                     [ngClass]="paymentInvalidFlags.title ? 'ng-invalid ng-dirty' : null"
                     [attr.aria-invalid]="paymentInvalidFlags.title"
                     [attr.aria-describedby]="paymentInvalidFlags.title ? 'title-invalid-help' : null"
                     pSize="large"/>
              @if (paymentInvalidFlags.title) {
                <small style="line-height: 1.5rem" class="text-error" role="alert" id="title-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
              }
            </div>
            @if ((paymentDataService.selectedOrganisationData?.customerGroup === CustomerGroup.SID) && newPaymentType.paymentMethod === PaymentMethodName.CREDITCARD) {
              <div class="col-12 flex align-items-center">
                <p-checkbox inputId="chargeback-card" [(ngModel)]="newPaymentType.isChargebackCard" [binary]="true" size="large"/>
                <label for="chargeback-card" class="ml-2 text-lg">{{ i18n.i18nLng()['CHARGEBACKCARD'] }}</label>
              </div>
            }
          </div>
        </fieldset>
      </div>
      <ng-template #footer class="pt-3">
        <div class="flex w-full align-items-center justify-content-between">
          <div class="text-sm">
            <sup class="sps-sup">*</sup><span><i>{{ i18n.i18nLng()['REQUIREDHELP'] }}</i></span>
          </div>
          <div class="flex gap-2">
            <p-button [label]="i18n.i18nLng()['CANCEL']" severity="secondary" (click)="cancelAddPaymentType()"/>
            <p-button [label]="i18n.i18nLng()['SAVE']" (onClick)="saveNewPaymentType()" [disabled]="addPaymentInProgress"/>
          </div>
        </div>
      </ng-template>
    </p-dialog>
  }

  <!-- edit payment type dialogs -->
  @if (editPaymentDialog.visible) {
    <p-dialog [modal]="true"
              [(visible)]="editPaymentDialog.visible"
              [style]="{width: '50rem'}"
              [closable]="false"
              [resizable]="false"
              [draggable]="false"
              styleClass="custom-header-dialog">
      <ng-template #header>
        <div>
          <span class="p-dialog-title">{{ i18n?.i18nLng()[editPaymentDialog?.i18nTitleKey] }}</span>
        </div>
        <p-button icon="pi pi-times"
                  [text]="true"
                  [rounded]="true"
                  styleClass="p-dialog-close-button"
                  severity="secondary"
                  [attr.aria-label]="i18n.i18nLng()['CLOSE']"
                  (click)="cancelEditPaymentData()"/>
      </ng-template>

      <div class="flex flex-column gap-3 align-self-stretch pb-4">
        <fieldset class="sps-fieldset form-data-container separator">
          <div class="grid w-full">
            <div class="col-6 flex flex-column gap-2">
              <label for="payment-category">{{ i18n.i18nLng()['PAYMENTMETHOD'] }}</label>
              <input pInputText id="payment-category" [value]="i18n.i18nLng()[editPaymentData?.paymentMethod]" [disabled]="true" pSize="large"/>
            </div>
            <div class="col-6 flex flex-column gap-2">
              <label for="payment-type">{{ i18n.i18nLng()['PAYMENTTYPEDESCRIPTION'] }}</label>
              <input pInputText id="payment-type" [value]="editPaymentData?.title" [disabled]="true" pSize="large"/>
            </div>
          </div>
        </fieldset>
        @switch (editPaymentDialog.type) {
          @case (PaymentDialogType.ACTIVATION) {
            <admin-payment-type-activation [paymentData]="editPaymentData"
                                           [tenantId]="tenantId"
                                           (forceCloseDialog)="cancelEditPaymentData()"
                                           (activationEnabled)="enableActivation($event)"
                                           (shopDataChanged)="onShopDataChanged($event)">
            </admin-payment-type-activation>
          }
          @case (PaymentDialogType.PAYMENTCONTRACT) {
            <admin-payment-type-contract [paymentTypeContractData]="paymentTypeContractData"
                                         [tenantId]="tenantId"
                                         (activationEnabled)="enableActivation($event)">
            </admin-payment-type-contract>
          }
          @case (PaymentDialogType.ACTIVATIONRESULT) {
            <admin-config-result [activationResult]="activationServiceResult" titleColumnWidth="60px"></admin-config-result>
          }
          @case (PaymentDialogType.PAYMENTTYPE) {
            <admin-payment-type-config [paymentData]="editPaymentData"
                                       [paymentInvalidFlags]="paymentInvalidFlags"
                                       [customerGroup]="paymentDataService.selectedOrganisationData.customerGroup"
                                       [chargebackCards]="chargebackCreditCards">
            </admin-payment-type-config>
          }
          @case (PaymentDialogType.PAYOUTDETAILS) {
            @switch (editPaymentData.paymentMethod) {
              @case (PaymentMethodName.PAYPAL) {
                <admin-payment-type-payout [paymentData]="editPaymentData" [paymentInvalidFlags]="paymentInvalidFlags"></admin-payment-type-payout>
              }
              @default {
                <admin-payment-type-payout [paymentData]="editPaymentData" [paymentInvalidFlags]="paymentInvalidFlags" (ibanValidated)="onIbanValidated($event)"></admin-payment-type-payout>
              }
            }
          }
          @case (PaymentDialogType.EMAILNOTIFICATION) {
            <admin-payment-type-email [paymentData]="editPaymentData" [paymentInvalidFlags]="paymentInvalidFlags"></admin-payment-type-email>
          }
        }
      </div>
      <ng-template #footer>
        <div class="flex w-full align-items-center justify-content-between">
          <div class="text-sm">
            @if (editPaymentDialog.type !== PaymentDialogType.PAYMENTTYPE || editPaymentData.active) {
              <sup class="sps-sup">*</sup><span><i>{{ i18n.i18nLng()['REQUIREDHELP'] }}</i></span>
            }
          </div>
          <div class="flex gap-2">
            @if (editPaymentDialog.type === PaymentDialogType.ACTIVATIONRESULT) {
              <p-button [label]="i18n.i18nLng()['CLOSE']" (click)="cancelEditPaymentData(false, true)"/>
            } @else {
              <p-button [label]="i18n.i18nLng()['CANCEL']" severity="secondary" (click)="cancelEditPaymentData()"/>
              @if (editPaymentDialog.type === PaymentDialogType.ACTIVATION) {
                <p-button [label]="i18n.i18nLng()['NEXT']" (onClick)="processShopOnboarding()" [disabled]="!activationEnabled"/>
              } @else {
                @if (editPaymentDialog.type === PaymentDialogType.PAYMENTCONTRACT) {
                  <p-button [label]="i18n.i18nLng()['SUBMIT']" (onClick)="processShopOnboarding()" [disabled]="!activationEnabled"/>
                } @else {
                  <p-button [label]="i18n.i18nLng()['SAVE']" (onClick)="checkValidPaymentDataOnSave()"/>
                }
              }
            }
          </div>
        </div>
      </ng-template>
    </p-dialog>
  }

  <div class="grid">
    <div class="col-12">
      <p-card class="h-full">
        <ng-template pTemplate="title">
          <div class="text-sm text-primary mb-1">
            {{ paymentDataService?.selectedOrganisationName }}
          </div>
          <div [ngClass]="layoutService.isMobile() ? 'flex flex-column gap-2 align-items-start' : 'flex flex-1 gap-2 align-self-stretch align-items-center'">
            <div class="flex flex-1 align-items-center gap-3">
              <div style="word-break: keep-all">{{ totalRecords.toString() + ' ' + i18n?.i18nLng()['PAYMENTTYPES'] }}</div>
            </div>
            <p-button [label]="i18n.i18nLng()['CLEAR']"
                      [ariaLabel]="i18n?.i18nLng()['CLEARALLFILTERS']"
                      [pTooltip]="i18n?.i18nLng()['CLEARALLFILTERS']"
                      tooltipPosition="top"
                      [outlined]="true"
                      icon="pi pi-filter-slash"
                      (click)="clearTableFilters()"/>
            @if(totalRecords === 0 || !adminMenuActive) {
              <p-button [label]="i18n.i18nLng()['ADDPAYMENTTYPE']"
                        [ariaLabel]="i18n?.i18nLng()['ADDPAYMENTTYPE']"
                        icon="pi pi-plus-circle"
                        (click)="addPaymentType()"/>
            } @else {
              <p-split-button icon="pi pi-user-edit"
                              [label]="i18n?.i18nLng()['DETAILS']"
                              [model]="adminMenuItems"
                              [disabled]="!adminMenuActive"
                              (onClick)="showDetailsDialog()"
                              [expandAriaLabel]="i18n.i18nLng()['SPLITBUTTONEXPANDINFO']"
                              [pTooltip]="i18n.i18nLng()['SPLITBUTTONINFO']"
                              tooltipPosition="top"/>
            }
          </div>
        </ng-template>
        @if (!tableControlService.refreshTableConfig()) {
          <sps-table [tableConfig]="tableConfig()"
                     [rows]="rows"
                     [tableListProvider]="tableListProvider"
                     [model]="paymentTypes"
                     [tableControlService]="tableControlService"
                     [scrollHeightOffset]="scrollHeightOffset"
                     [minScrollHeight]="minScrollHeight"
                     [freezeColumns]="true"
                     [showTogglerIcon]="false"
                     [selectedRowsData]="selectedRowData"
                     (selectionChanged)="onSelectionChanged($event)"
                     (rowsCountChanged)="rowsCountChanged($event)"
                     (totalRecordsChanged)="onTotalRecordsChanged($event)">
          </sps-table>
        }
      </p-card>
    </div>
  </div>
}
